import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useAppointmentSessionState } from "../../../../../hooks/v3/hooks/use-appointment-session-state.js";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
const ClientSessionManager = ({
  children,
  initialRoute
}) => {
  const [{ goTo }, { queryParams, currentRoute }] = useRoutingContext();
  const { getAppointmentSessionState, setAppointmentSessionState, removeAppointmentSessionState } = useAppointmentSessionState();
  const shouldRedirect = React.useMemo(() => {
    const appointmentSessionState = getAppointmentSessionState();
    const hasQueryParams = Object.keys(queryParams).length;
    const hasSessionStateQueryParams = appointmentSessionState && Object.keys(appointmentSessionState.queryParams).length;
    const isFirstStep = currentRoute === "";
    if (isFirstStep && !hasQueryParams && hasSessionStateQueryParams && appointmentSessionState.currentRoute !== initialRoute) {
      return true;
    }
    return false;
  }, [currentRoute, getAppointmentSessionState, initialRoute, queryParams]);
  React.useEffect(() => {
    const redirectUser = () => {
      const appointmentSessionState = getAppointmentSessionState();
      if (shouldRedirect && appointmentSessionState) {
        goTo(appointmentSessionState.currentRoute, appointmentSessionState.queryParams);
      }
    };
    if (currentRoute === "confirmation") {
      removeAppointmentSessionState();
    } else if (currentRoute !== "") {
      setAppointmentSessionState();
    } else if (currentRoute === "") {
      redirectUser();
    }
  }, [
    currentRoute,
    getAppointmentSessionState,
    goTo,
    removeAppointmentSessionState,
    setAppointmentSessionState,
    shouldRedirect
  ]);
  if (shouldRedirect) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LoaderScreen, null));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
ClientSessionManager.displayName = "ClientSessionManager";
export {
  ClientSessionManager as default
};
//# sourceMappingURL=ClientSessionManager.js.map
